import Vue from 'vue'
import store from '@/store'

Vue.directive('role', {
  inserted(el, binding) {
    const userRole = store?.state?.AppActiveUser?.role || ''
    const { value, modifiers } = binding
    
    // If no required role provided — allow always
    if (
      value === undefined ||
      value === null ||
      value === '' ||
      (Array.isArray(value) && value.length === 0)
    ) {
      return
    }

    // Normalize roles to array
    let required = typeof value === 'string'
      ? value.split(',').map(r => r.trim()).filter(Boolean)
      : Array.isArray(value)
        ? value
        : []

    if (required.length === 0) {
      return
    }

    // Check logic: .all = must match every role, default = match any role
    const hasRole = modifiers.all
      ? required.every(r => r === userRole)
      : required.some(r => r === userRole)

    if (!hasRole) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
})
